<svelte:options
  customElement={{
    tag: 'teo-app',
    extend: extendWithStyles,
  }}
/>

<script lang="ts" module>
  import { TeoCore } from '@/teoCore/TeoCore';
  import AppElement from '@/ui/components/AppElement.svelte';
  import DebugSidebar from '@/ui/components/debug/DebugSidebar.svelte';
  import { TeoContextProvider } from '@/utils/teo-context';

  import { extendWithStyles } from './web-component-utils';
</script>

<script lang="ts">
  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoContextProvider {teoCore}>
  <AppElement>
    <slot />
  </AppElement>
  <DebugSidebar />
  {#if __NET_RECORDER__}
    <!-- dev server only; lazy so the widget never enters production chunks -->
    {#await import('@/devtools/netRecorder/NetRecorderWidget.svelte') then { default: NetRecorderWidget }}
      <NetRecorderWidget />
    {/await}
  {/if}
</TeoContextProvider>
